var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 25C46 13.402 36.598 4 25 4C13.402 4 4 13.402 4 25C4 36.598 13.402 46 25 46V50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50V46C36.598 46 46 36.598 46 25Z",
    fill: "#71B3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37.25V27H12.75C11.6454 27 10.75 26.1046 10.75 25C10.75 23.8954 11.6454 23 12.75 23H23V12.75C23 11.6454 23.8954 10.75 25 10.75C26.1046 10.75 27 11.6454 27 12.75V23H37.25C38.3546 23 39.25 23.8954 39.25 25C39.25 26.1046 38.3546 27 37.25 27H27V37.25C27 38.3546 26.1046 39.25 25 39.25C23.8954 39.25 23 38.3546 23 37.25Z",
    fill: "#71B3DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f39b7c724bc822282e6c576b22bfc75e.svg";
export { ForwardRef as ReactComponent };